export default __webpack_public_path__ + "static/media/videos.b0175bae.svg";